import { SeoMapper } from '@search/router/src';
import { DealType } from '@search/filter-enums/enums/DealType';

export const dealTypeMapper = new SeoMapper('dealTypeMapper', {
    kupit: DealType.SELL,
    snyat: DealType.RENT,
    UNKNOWN: DealType.UNKNOWN,
    // impl_not_set: DealType.UNKNOWN
} as const);
